import React, { useEffect, useState } from 'react';
import classes from './cookie-consent.module.scss';

const CookieBanner = () => {
    const [hideBanner, setHideBanner] = useState(() => {
        return localStorage.getItem('hideBanner') === 'true';
    });

    useEffect(() => {
        if (!hideBanner) {
            const timer = setTimeout(() => {
                setHideBanner(true);
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, [hideBanner]);

    const handleAgree = () => {
        setHideBanner(true);
        localStorage.setItem('hideBanner', 'true');
    };

    return (
        <div className={`${classes.banner} ${hideBanner ? classes.banner_hidden : ""}`}>
            <div className={classes.header}>
                <h4 className={classes.title}>We Value Your Privacy</h4>
                <button
                    type="button"
                    className={classes.close_btn}
                    onClick={handleAgree}
                    aria-label="Close cookie banner"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                    </svg>
                </button>
            </div>
            <p className={classes.text}>
                We use cookies to enhance your browsing experience and analyse site traffic.
                By continuing, you agree to our{' '}
                <a href={`${process.env.PUBLIC_URL}/privacy-policy`} target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>.
            </p>
            <div className={classes.actions}>
                <button type="button" className={classes.decline_btn} onClick={handleAgree}>
                    Decline
                </button>
                <button type="button" className={classes.accept_btn} onClick={handleAgree}>
                    Accept All
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
